import { render, staticRenderFns } from "./CommonHeaderGuoJiao.vue?vue&type=template&id=1abf81ab&scoped=true"
import script from "./CommonHeaderGuoJiao.vue?vue&type=script&lang=js"
export * from "./CommonHeaderGuoJiao.vue?vue&type=script&lang=js"
import style0 from "./CommonHeaderGuoJiao.vue?vue&type=style&index=0&id=1abf81ab&scoped=true&lang=less"
import style1 from "./CommonHeaderGuoJiao.vue?vue&type=style&index=1&id=1abf81ab&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abf81ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1abf81ab')) {
      api.createRecord('1abf81ab', component.options)
    } else {
      api.reload('1abf81ab', component.options)
    }
    module.hot.accept("./CommonHeaderGuoJiao.vue?vue&type=template&id=1abf81ab&scoped=true", function () {
      api.rerender('1abf81ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/CommonHeaderGuoJiao.vue"
export default component.exports